export const BOOKING_SERVICES_CHANGED = 'booking-services-changed';

export function notifyBookingServicesChanged() {
  window.dispatchEvent(new Event(BOOKING_SERVICES_CHANGED));
}
